import { useEffect, useRef, useState } from "react";
import NivoPieChart from "../../../Nivo/Nivo_Piechart";
import { baseURL } from "../../../Util/axios_helper";
import { useDispatch, useSelector } from "react-redux";
import StackedBarChart from "../../../ChartsJs/StatckedBar";
import {
  downloadPDF,
  downloadPDFFOrNivo,
} from "../../../ChartsJs/DownlaodExportImage";
import { KendoGrid } from "../../../Kendo/kendo_grid";
import { PdfModal } from "../../../Util/common";

const ExecutionVendor = ({ year, type, filter, metric, metricvalue }) => {
  const { ExecutionData } = useSelector((state) => state.execution);

  const [label, setlabel] = useState([]);
  const [data, setData] = useState([]);
  const [legend, setLegend] = useState([]);
  const [Piechartdata, setPiechartdata] = useState([]);
  const outGoingCallREf = useRef(null);
  const PDFChartREf = useRef(null);

  const [minVal, setminVal] = useState(0);
  const [maxVal, setmaxVal] = useState(11);

  const [reportcolumn, setreportcolumn] = useState({
    Reportflag: false,
    title: "",
    exportFName: "",
    refreshflag: 0,
    reportvalue: "",
  });

  function getISOWeekNumber(date) {
    const tempDate = new Date(date);
    tempDate.setHours(0, 0, 0, 0);
    tempDate.setDate(tempDate.getDate() + 4 - (tempDate.getDay() || 7));
    const yearStart = new Date(tempDate.getFullYear(), 0, 1);
    const weekNumber = Math.ceil(((tempDate - yearStart) / 86400000 + 1) / 7);
    return weekNumber;
  }

  function getMinAndMaxWeekNumbers() {
    const today = new Date();
    const maxWeekNumber = getISOWeekNumber(today);

    const minDate = new Date(today);
    minDate.setDate(today.getDate() - 12 * 7);
    const minWeekNumber = getISOWeekNumber(minDate);

    return { maxWeekNumber, minWeekNumber };
  }

  useEffect(() => {
    if (ExecutionData && ExecutionData.Table3) {
      const xAxis = ExecutionData.Table3.XAxis;
      const legends = ExecutionData.Table3.legends;
      const data = ExecutionData.Table3.yAxisData;
      if (type == "Week" || (metric != "" && metric != "All Matrix")) {
        setlabel(xAxis);
        setLegend(legends);
        setData(data);

        if (data.length > 12) {
          const { maxWeekNumber, minWeekNumber } = getMinAndMaxWeekNumbers();
          setmaxVal(maxWeekNumber);
          setminVal(minWeekNumber);
        } else {
          setmaxVal(11);
          setminVal(0);
        }
      } else {
        const { XAxis, yAxisData } = ExecutionData.Table3;

        if (Array.isArray(XAxis) && Array.isArray(yAxisData)) {
          const piedata = XAxis.map((x, index) => ({
            id: x,
            label: x,
            value: yAxisData[index],
          }));

          setPiechartdata(piedata);
        }
      }
    }
  }, [ExecutionData]);

  return (
    <>
      <div className="card">
        <div className="col-xs-12 mt-2 files">
          {/* <div
            className="ms-2 me-2 "
            title="Export to Pdf"
            style={{
              position: "relative",
              float: "right",
              cursor: "pointer",
            }}
            onClick={() =>
              ExecutionData && (type == "Week"|| (metric != "" && metric != "All Matrix"))
                ? downloadPDF("Vendor", "Vendor Services Charges", 55, 3)
                : downloadPDFFOrNivo(outGoingCallREf, "Vendor Services Charges", 1, 1)
            }
          >
            <span className="files-icon">
              <i class="las la-image"></i>
            </span>
          </div> */}
          <a
            href={`#`}
            onClick={() => {
              var modal = document.getElementById("VENModalPDF");
              modal.style.display = "block";
              var span = document.getElementById("VENPDFclose");
              span.onclick = function () {
                modal.style.display = "none";
              };

              // When the user clicks anywhere outside of the modal, close it
              window.onclick = function (event) {
                if (event.target == modal) {
                  modal.style.display = "none";
                }
              };
            }}
          >
            <div
              title="View Report"
              className="ms-2 me-2"
              style={{
                position: "relative",
                float: "right",
                cursor: "pointer",
              }}
            >
              <span className="files-icon">
                <i className="las la-image"></i>
              </span>
            </div>
          </a>
          {/* Trigger button for modal */}
          <a
            href={`#`}
            onClick={() => {
              var modal = document.getElementById("VModal");
              modal.style.display = "block";
              var span = document.getElementById("EVclose");
              span.onclick = function () {
                modal.style.display = "none";
              };

              // When the user clicks anywhere outside of the modal, close it
              window.onclick = function (event) {
                if (event.target == modal) {
                  modal.style.display = "none";
                }
              };

              setreportcolumn((prevreportcolumn) => ({
                ...prevreportcolumn,
                Reportflag: true,
                title: "Total Vendor Sales Report",
                exportFName: "Sales_Vendor_Report",
                refreshflag: reportcolumn.refreshflag + 1,
                reportvalue: "vendor",
              }));
            }}
          >
            <div
              title="View Report"
              className=""
              style={{
                position: "relative",
                float: "right",
                cursor: "pointer",
              }}
            >
              <span className="files-icon">
                <i className="las la-file-alt"></i>
              </span>
            </div>
          </a>
        </div>

        <div className="card-body">
          <div style={{ height: 400, fontWeight: "bold" }}>
            <div style={{ textAlign: "center" }}>Vendor</div>
            {(ExecutionData && type == "Week") ||
            (metric != "" && metric != "All Matrix") ? (
              <StackedBarChart
                data={data}
                type={"bar"}
                labels={label}
                legend={legend}
                titl={year}
                XAxisLabel={type}
                YAxisLabel={"Execution"}
                id={"Vendor"}
                chartType={"Decorchart"}
                countOnLead={false}
                minVal={minVal}
                maxVal={maxVal}
                dollar={true}
              />
            ) : (
              <NivoPieChart
                data={Piechartdata}
                IsOutingcalls={false}
                id={outGoingCallREf}
                dollar={true}
              />
            )}
          </div>
        </div>
        {/* <!-- Vendor Report Modal --> */}
        <div id="VModal" class="cmodal">
          <div class="cmodal-content">
            <div className="modal-header">
              <h5 className="modal-title-popup">{reportcolumn.title}</h5>
              <span class="close" id="EVclose">
                &times;
              </span>
            </div>
            <div className="row">
              <div className="col-md-12">
                {reportcolumn.Reportflag && (
                  <KendoGrid
                    exportFileName={reportcolumn.exportFName}
                    name={"Vendor_Sales_report"}
                    paggable={true}
                    url={`${baseURL}Analytics/Get_ExecutionData_Report?type=${type}&years=${year}&filter=${filter}&metrics=${metric}&value=${metricvalue}&reportType=${reportcolumn.reportvalue}`}
                    schema={{}}
                    refreshWhen={reportcolumn.refreshflag}
                    columns={[
                      {
                        field: "EventNumber",
                        title: "Event No",
                        width: 100,
                      },

                      {
                        field: "EventName",
                        title: "Event Name",
                        width: 150,
                      },
                      {
                        field: "EventType",
                        title: "Event Type",
                        width: 100,
                      },
                      {
                        field: "GuaranteedDate",
                        title: "Guaranteed Date",
                        width: 100,
                      },
                      {
                        field: "FunctionStartDate",
                        title: "Start Date",
                        width: 150,
                      },
                      {
                        field: "FunctionEndDate",
                        title: "End Date",
                        width: 150,
                      },
                      {
                        field: "FunctionLocation",
                        title: "Function Location",
                        width: 150,
                      },

                      {
                        field: "PaymentAmount",
                        title: "Payment Amount",
                        width: 150,
                      },
                      {
                        field: "PaymentReceivedDate",
                        title: "Payment Received Date",
                        width: 150,
                      },
                      {
                        field: "PaymentStatus",
                        title: "Payment Status",
                        width: 150,
                      },
                      {
                        field: "PaymentType",
                        title: "Payment ype",
                        width: 150,
                      },
                      {
                        field: "ReferralType",
                        title: "Referral Type",
                        width: 150,
                      },
                      {
                        field: "Culture",
                        title: "Culture",
                        width: 150,
                      },
                      {
                        field: "Salesperson",
                        title: "Salesperson",
                        width: 150,
                      },
                    ]}
                    height={400}
                    showOptions={false}
                    showEdit={false}
                    showDelete={false}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {/* <!-- End Vendor Report Modal/ --> */}
        {/* <!-- Decor PDF Modal --> */}
        <PdfModal
          chart={
            (ExecutionData && type == "Week") ||
            (metric != "" && metric != "All Matrix") ? (
              <StackedBarChart
                data={data}
                type={"bar"}
                labels={label}
                legend={legend}
                titl={year}
                XAxisLabel={type}
                YAxisLabel={"Execution"}
                id={"PDFVendor"}
                chartType={"Decorchart"}
                countOnLead={false}
                minVal={minVal}
                maxVal={maxVal}
                dollar={true}
                ChartHeight={600}
                ValueFontSize={12}
              />
            ) : (
              <NivoPieChart
                data={Piechartdata}
                IsOutingcalls={false}
                id={PDFChartREf}
                dollar={true}
              />
            )
          }
          modalId={"VENModalPDF"}
          modalcloseId={"VENPDFclose"}
          modalTitle={"Vendor"}
          PDFDownload={() =>
            ExecutionData &&
            (type == "Week" || (metric != "" && metric != "All Matrix"))
              ? downloadPDF("PDFVendor", "Vendor", 90, 3)
              : downloadPDFFOrNivo(PDFChartREf, "Vendor", 1, 1)
          }
        />
        {/* <!-- End Decor PDF Modal/ --> */}
      </div>
    </>
  );
};

export default ExecutionVendor;
